<template>
  <div class="modal" tabindex="-1" role="dialog" id="planPagos">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title text-center">Plan de Pagos</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <input type="number" v-model.number="xxcolegiatura" placeholder="Colegiatura total">
            <input type="number" v-model.number="xxcuotas" placeholder="Cantidad de cuotas">
            <button type="button" class="btn btn-sm btn-azul" @click="regenerar()" style="margin-left:8px">Generar</button>
          </div>

          

          <table class="table table-condensed table-striped table-hover">
            <thead>
              <tr>
                <th scope="col" class="text-center">Nro. cuota</th>
                <th scope="col">Fecha Prevista</th>
                <th scope="col">Monto(Bs)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="c.nro_cuota" v-for="c in cuotas">
                <th scope="row" class="text-center">{{c.nro_cuota}}</th>
                <td> <Fecha :model="c" :default="c.fecha"/> </td>
                <td> <Monto :model="c" :default="c.monto"/> </td>
              </tr>
            </tbody>
          </table>
        </div> 
        <!-- <p class="text-center text-primary" style="padding:8px"> <span class="text-danger">*</span> Al modificar este plan de pagos, asegurese que los montos y fechas concuerden con lo establecido en el programa. </p> -->
        <p class="text-center text-danger"> {{msg}} </p>
        <p v-show="novalido" class="text-center text-danger"> <b>AVISO:</b> Los montos no coinciden con el monto de la colegiatura. </p>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" @click="confirmar()">Guardar Nuevo Plan</button>
          <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import Fecha from '@/components/AFecha'
import Monto from '@/components/AMonto'
import gql from 'graphql-tag'
export default {
  props: { 
    cuotas:{type:Array,required:true},
    cole:{type:Number,required:false,default:0}, 
    cuotas_validas:{type:Object,required:false},
    save:{type:Boolean,required:false,default:false},
  },
  components:{ Fecha,Monto },
  data(){
    return{
      novalido: false,
      colegiatura:0,
      xxcolegiatura: null,
      xxcuotas: null,
      msg: null,
    }
  },
  watch:{
    cuotas:{
      deep:true,
      handler(a){
        if( a ){
          var vue = this;
          this.colegiatura = 0;
          a.forEach( function(e){
            vue.colegiatura += e.monto;
          })
          this.xxcolegiatura = this.colegiatura;
          this.xxcuotas = a.length;
        }
        if( this.cole ){
          if( this.cole != this.colegiatura ) this.novalido = true
          else this.novalido = false

          if( this.cuotas_validas ) this.cuotas_validas.valido = !this.novalido
        }
        window.console.log( this.colegiatura );
      }
    }
  },
  methods:{
      parseFecha( fe ){
          var fs = fe.split( "-" );
          return fs[2]+" / "+fs[1]+" / "+fs[0];
      },
      confirmar(){
        this.msg = null;
        var vue = this;
        var opt = {
          okText:"Guardar Plan",
          cancelText:"volver",
          backdropClose:false,
          animation: 'bounce',
          loader: true, 
          type:"classic"
        }
        var message = {
          title: 'Confirmar Nuevo Plan',
          body: '<br> <b></b>'
        };
        this.$dialog.confirm(message,opt)
        .then(function( dialog ) { 
          vue.guardar( dialog );
        })
        .catch(function() { });
      },
      guardar( dialog ){
        var idins = window.localStorage.getItem( 'idinscripcion' );
        var body = {id:parseInt(idins),cuotas:this.cuotas }
        window.console.log( "guardar",dialog,idins,window.stringifyObject(body) );

        var sql = gql`mutation{ reprogramarPlanPagos(input:${window.stringifyObject(body)}){ ok errors{message} } }`;
        window.console.log( "regeranarPLAN>> ",sql )
        this.$apollo.mutate({
          mutation: sql,
        }).then((data) => {
          var datos = data.data.reprogramarPlanPagos;
          window.console.log( "Reprogramado ",window.stringifyObject(datos) )
          if( datos.ok ){
            window.alert( "Plan de pagos regenerado exitosamente." )
          }else{
            var errores = JSON.stringify(data.data.reprogramarPlanPagos.errors);
            var obj = JSON.parse( errores );
            var vals = '';
            obj.forEach(function(k){ delete k.__typename; vals += Object.values(k)+" \n\t"; });
            this.msg = vals;
          }
          dialog.close();

        }).catch((error) => {
          this.msg = error;
          window.console.error(error)
          dialog.close();
        })
      },

      correo(){
        /*window.Email.send({
            Host : "45.77.105.50",
            Username : "informador@esam.edu.bo",
            Password : "informador@esam.edu.bo",
            To : 'eclipseconsol@gmail.com,dsaldiasv@gmail.com',
            From : "aamador@esam.edu.bo",
            Subject : "Plan de Pagossss",
            Body : "Regenerando de plan de pagos"
        }).then(
          message => {window.console.log(message) }
        );*/
      },

      regenerar(){
        this.correo();
        this.msg = null;
        // window.console.log( "JAJAJAJ",this.xxcolegiatura,this.xxcuotas  )
        if( !this.xxcolegiatura || !this.xxcuotas ) return;
        if( this.xxcuotas == 0 ) return;
        this.$emit( 'regenerar',this.xxcolegiatura,this.xxcuotas );
      },
  }
};
</script>